function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M224 40.73c-101.217 0-183.27 82.053-183.27 183.27s82.053 183.27 183.27 183.27c101.218 0 183.27-82.052 183.27-183.27s-82.052-183.27-183.27-183.27zM0.004 224c0-123.71 100.286-223.996 223.996-223.996s223.996 100.286 223.996 223.996c0 123.709-100.287 223.996-223.996 223.996s-223.996-100.287-223.996-223.996zM203.637 142.547c0-11.246 9.117-20.363 20.363-20.363h0.203c11.247 0 20.363 9.117 20.363 20.363s-9.117 20.363-20.363 20.363h-0.203c-11.247 0-20.363-9.117-20.363-20.363zM224 203.637c11.247 0 20.363 9.117 20.363 20.363v81.453c0 11.247-9.117 20.363-20.363 20.363s-20.363-9.117-20.363-20.363v-81.453c0-11.247 9.117-20.363 20.363-20.363z"
});

function SvgSxCircleInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 448,
    height: 448,
    viewBox: "0 0 448 448",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSxCircleInfo);
export default __webpack_public_path__ + "static/media/sx-circle-info.7a83c5d5.svg";
export { ForwardRef as ReactComponent };